import { SYMPTOMS, IMPACT_QUESTIONS } from "./questions";

// Calcula el indicador orientativo de impacto.
// Reglas:
// - Alertas prevalecen sobre puntaje.
// - Solo cuentan respuestas numéricas (0..3). "prefer_not" no equivale a cero: se excluye.
// - % = suma / (número respondido * 3).
// - < 70% respondido = orientación insuficiente (no verde).
// - Ajustes por impacto en vida diaria: bastante -> mínimo moderado; mucho -> alto.
export function computeResult(state) {
  const {
    symptoms = {},
    impact = {},
    emotional = {},
    immediate = {},
    priority = {},
  } = state;

  // Emergencias inmediatas
  const immediateHits = Object.entries(immediate)
    .filter(([, v]) => v === "yes")
    .map(([k]) => k);

  // Prioritarias
  const priorityHits = Object.entries(priority)
    .filter(([, v]) => v === "yes")
    .map(([k]) => k);

  // Autolesión
  const selfHarm = emotional.hacerse_dano === "yes";

  // Puntaje de síntomas
  const totalSymptoms = SYMPTOMS.length;
  let answeredCount = 0;
  let sum = 0;
  const symptomIntensities = [];
  for (const s of SYMPTOMS) {
    const val = symptoms[s.id];
    if (typeof val === "number") {
      answeredCount += 1;
      sum += val;
      symptomIntensities.push({ id: s.id, text: s.text, value: val });
    }
  }
  const answeredRatio = totalSymptoms > 0 ? answeredCount / totalSymptoms : 0;
  const maxPossible = answeredCount * 3;
  const percent = maxPossible > 0 ? Math.round((sum / maxPossible) * 100) : 0;

  // Nivel base por porcentaje
  let level;
  if (percent <= 24) level = "bajo";
  else if (percent <= 54) level = "moderado";
  else level = "alto";

  // Ajustes por impacto (vida_diaria, sueño, trabajo)
  const vida = impact.vida_diaria;
  const sueno = impact.sueno;
  const trabajo = impact.trabajo;

  if (typeof vida === "number" && vida >= 2 && level === "bajo") level = "moderado";
  if (
    (typeof vida === "number" && vida === 3) ||
    (typeof sueno === "number" && sueno === 3) ||
    (typeof trabajo === "number" && trabajo === 3)
  ) {
    if (level !== "alto") level = "alto";
  }

  // Datos insuficientes
  const insufficient = answeredRatio < 0.7;
  if (insufficient && level === "bajo") {
    level = "insuficiente";
  }

  // Top 3 síntomas con mayor intensidad (solo >0)
  const topSymptoms = symptomIntensities
    .filter((s) => s.value > 0)
    .sort((a, b) => b.value - a.value)
    .slice(0, 3);

  // Áreas afectadas (impacto >=2)
  const affectedAreas = IMPACT_QUESTIONS.filter((q) => {
    const v = impact[q.id];
    return typeof v === "number" && v >= 2;
  }).map((q) => q.text);

  return {
    percent,
    level, // 'bajo' | 'moderado' | 'alto' | 'insuficiente'
    answeredRatio,
    answeredCount,
    totalSymptoms,
    topSymptoms,
    affectedAreas,
    immediateHits,
    priorityHits,
    selfHarm,
    hasImmediate: immediateHits.length > 0,
    hasPriority: priorityHits.length > 0,
  };
}

export function levelLabel(level) {
  switch (level) {
    case "bajo":
      return { label: "Impacto bajo", color: "green" };
    case "moderado":
      return { label: "Impacto moderado", color: "yellow" };
    case "alto":
      return { label: "Impacto alto", color: "yellow-strong" };
    case "insuficiente":
      return { label: "Orientación insuficiente", color: "neutral" };
    default:
      return { label: "Sin información", color: "neutral" };
  }
}
